import { mapState } from 'vuex';

export default {
    name: 'wai-journals',
    props: {
        cui : String,
        cuis : Array
    },

    data : function(){

        return {
            loading : false,
            data : null,
            current : null,
            preview : {}
        }

    },

    watch: {
        cuis : function(){
            this.load()
        },
        cui : function(){
            this.load()
        }
    },

    created : function(){

        this.load()

    },

    computed: mapState({
        auth : state => state.auth,
        maincuiname : function(){

            if(this.current && this.current.main){
                return this.current.main.Name
            }

            return ''
        },
        othercuinames : function(){

            if(this.current && this.current.others){
                return _.map(this.current.others, function(c){
                    return c.Name
                })
            }

            return ''
        },

        cuistring : function(){
            return this.current.main + this.current.others.join('')
        }
    }),

    methods : {
        articlevisibility : function(isVisible, entry){

            
            if(isVisible){

                var t = this

                var sha = entry.target.getAttribute('sha');

                console.log("LOAD")

                this.loadPreview(sha)
              
            }
            
        },
        loadPreview : function(sha){
            var allcui = _.concat([this.cui], this.cuis);

            var h = sha + this.current.main + this.current.others.join('')

            var t = this

            if(!this.preview[h]){

                this.$root.api.wai.article.preview({

                    sha : sha,
                    cuis : JSON.stringify(allcui)

                }).then(results => {

                    var d = t.$f.group(results.data, function(d){
                        return d.type + d.num
                    })

                    d = _.map(d, function(gr){

                        var t = gr[0].content

                        var c = _.map(gr, function(g){
                            return {
                                cui : g.CUI,
                                start : g.PosBeg,
                                end : g.PosEnd + 1,
                                name : g.name
                            }
                        })

                        c = _.sortBy(c, function(c){
                            return c.start
                        })

                        var intervals = _.map(c, function(c){
                            return {
                                start : Math.max(c.start - 50, 0),
                                end : Math.min(c.start + 50, t.length),
                            }
                        })

                        intervals = _.sortBy(intervals, function(i){
                            return i.start
                        })


                        var sintervals = [];

                        _.each(intervals, function(i){

                            var start = i.start;
                            var end = i.end;

                            /*var c = _.find(sintervals, function(interval){
                                if(interval.start >= start && interval.end <= end){
                                    return true
                                }
                            })

                            if (c){

                                c.start = start
                                c.end = end

                                return
                            }*/

                            var c2 = _.find(sintervals, function(interval){
                                if(interval.start <= start && interval.end >= end){
                                    return true
                                }
                            })

                            if (c2){
                                return
                            }

                            var c3 = _.find(sintervals, function(interval){
                                if((interval.start >= start && interval.start <= end) || (interval.end >= start && interval.start <= start)){
                                    return true
                                }
                            })

                            if (c3){

                                c3.start = Math.min(start, c3.start)
                                c3.end = Math.max(end, c3.end)

                                return
                            }

                            sintervals.push(i)

                        })


                        var text = ''

                        _.each(sintervals, function(i, l){

                            if(i.start) {
                                text += '...'

                                if(!i) text += ' '
                            }

                            var part = t.substr(i.start, i.end)

                            var dis = 0;

                            _.each(c, function(s){
                                if(s.start >= i.start && s.end <= i.end){

                                    var l = ''
                                    var l2 = ''
                    
                                        l = '<mark class="refcui" title="'+s.name+'">'
                                        l2 = '</mark>'
                    
                                    if(!l && !l2) return
                    
                                    var d = l.length
                                    var d2 = l2.length
                    
                                    part = part.substr(0, s.start - i.start + dis) + l + part.substr(s.start - i.start + dis)

                                    dis += d
                    
                                    part = part.substr(0, s.end - i.start + dis) + l2 + part.substr(s.end - i.start + dis)

                                    dis += d2

                                }
                
                            })

                            text += part.replace(/^[., _/\!\*\%\^\&\*@\(\)]/g, '').replace(/[., _/\!\*\%\^\&\*@\(\)]$/g, '')

                            

                            if(l == sintervals.length - 1 && i.end != t.length - 1 && text[text.length - 1].match(/[a-zA-Z0-9]/)){
                                text += '...'
                            }

                        })


                        return {
                            text : text,
                            cuis : c
                        }

                    })

                    var text = _.reduce(d, function(s, d, i){
                        return s + '<p class="p">' + d.text + '</p>'
                    }, '')


                    t.$set(t.preview, h, {
                        text : text
                    })

                }).catch(error => {

                    console.log(error)

                            

                })
            }
        },
        load : function(){

            this.data = null

            if(!this.cui || !this.cuis) return

            this.loading = true

            this.$root.api.wai.search.covidJournal({

                cui : this.cui,
                cuis : JSON.stringify(this.cuis)

            }).then(results => {

                if (this.loading){
                    this.loading = false

                    if (results.data.length)
                        this.data = results.data
                }
                else{
                    
                }

            }).catch(error => {

                console.log(error)

                if (this.loading){
                    this.loading = false
                }
                else{

                }                

            })

            var allcui = _.concat([this.cui], this.cuis);

            var cui = this.cui

            this.$root.api.wai.info.cui({
                cui : allcui
            }).then(results => {
                this.current = {

                    main : _.find(results.data, function(c){
                        return c.CUI == cui
                    }),

                    others : _.filter(results.data, function(c){
                        return c.CUI != cui
                    })
                }

            }).catch(error => {

                           

            })

        }
    },
}